import axios from 'axios'

export default {
  add_new: (params) => (
    axios.post(`participations`, params)
  ),
  get: (id) => (
    axios.get(`participations/${id}`)
  ),
  get_refund_proof: (id) => {
    axios({
      url: `refund-proof/${id}`,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'justificatif_remboursement.pdf');
      document.body.appendChild(link);
      link.click();
    });
  }
}


// WEBPACK FOOTER //
// ./src/api/participation.js